import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ps-panel" }
const _hoisted_2 = { class: "ps-panel-hd" }
const _hoisted_3 = { class: "ps-appear-row" }
const _hoisted_4 = { class: "ps-appear-info" }
const _hoisted_5 = { class: "ps-appear-desc" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "ps-lang-block" }
const _hoisted_9 = { class: "ps-appear-label" }
const _hoisted_10 = { class: "lang-slider-wrap" }
const _hoisted_11 = ["max", "value"]
const _hoisted_12 = { class: "lang-slider-labels" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "lang-selected-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('profile.appearance')), 1),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "Personalize o tema e idioma da interface.", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ps-appear-label" }, "Tema", -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.isDarkMode ? 'Escuro ativado' : 'Claro ativado'), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-ghost dark-toggle",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args)))
      }, [
        (_ctx.isDarkMode)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "☀ " + _toDisplayString(_ctx.$t('profile.lightMode')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "☾ " + _toDisplayString(_ctx.$t('profile.darkMode')), 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('profile.languageLabel')), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("input", {
          type: "range",
          class: "lang-slider",
          min: 0,
          max: _ctx.supportedLocales.length - 1,
          value: _ctx.localeIndex,
          step: "1",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onLocaleSlider($event)))
        }, null, 40, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportedLocales, (loc, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: loc.code,
              class: _normalizeClass(["lang-slider-tick", { active: _ctx.localeIndex === i }]),
              onClick: ($event: any) => (_ctx.switchLocale(loc.code))
            }, _toDisplayString(loc.flag), 11, _hoisted_13))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.supportedLocales[_ctx.localeIndex]?.flag) + " " + _toDisplayString(_ctx.supportedLocales[_ctx.localeIndex]?.label), 1)
      ])
    ])
  ]))
}